import { icons, LucideIcons } from "lucide-angular";

import { CoreMenuItem } from "@core/types";
import { menu } from "app/utils/config/menu";

const collectImportIcons = (items: CoreMenuItem[]): string[] => {
  const names: string[] = [];

  items.forEach((item) => {
    if (item.importIcon) {
      names.push(item.importIcon);
    }

    if (item.children?.length) {
      names.push(...collectImportIcons(item.children));
    }
  });

  return names;
};

const uniqueIcons = Array.from(new Set(collectImportIcons(menu)));
const registry = icons as LucideIcons;

export const coreMenuLucideIcons = uniqueIcons.reduce(
  (acc: LucideIcons, iconName: string) => {
    const icon = registry[iconName];

    if (icon) {
      acc[iconName] = icon;
    }

    return acc;
  },
  {} as LucideIcons
);
